import { render, staticRenderFns } from "./CADistributionChart.vue?vue&type=template&id=b91d8bda&"
import script from "./CADistributionChart.vue?vue&type=script&lang=js&"
export * from "./CADistributionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports